import React from 'react';

import { Image } from '../atom/Image';
import { breakpoint } from '../../../lib/style/ThemeStyle';

export const Picture = ({ image = { src: '@3x.jpg', alt: '' }, ...props }) => (
  <picture {...props}>
    <source
      media={`(max-width: ${breakpoint}px)`}
      srcSet={image.src.replace('@3x', '@2x')}
    />
    <Image src={image.src} alt={image.alt} style={{ verticalAlign: 'top' }} />
  </picture>
);
